<ng-template #content let-modal>
  <div class="modal-body">
    <div class="d-flex flex-fill justify-content-center">
      <h4 class="modal-title text-center col-12">
        {{ title }}
      </h4>
    </div>
    <div class="zaya-form-header">{{ text }}</div>
    <textarea *ngIf="includeDetail" class="form-control" name="detail" id="detail" cols="30" rows="5" [(ngModel)]="detailText"></textarea>
    <div class="d-flex flex-fill justify-content-center">
      <button *ngIf="mainAction" type="button" class="btn btn-primary modal-btn mr-2" (click)="onMainActionClicked()">{{ mainAction }}</button>
      <button type="button" class="btn btn-secondary modal-btn" (click)="modal.dismiss()">{{ buttonText }}</button>
    </div>
  </div>
</ng-template>
